import { Box } from '@mui/system';
import React, { useState } from 'react';
import { ClickAwayListener, Tooltip } from '@mui/material';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import { useTranslations } from 'hooks/useTranslations';
import { colors } from 'theme/colors';
import { EIconTypes } from 'constants/Icons';
import Icon from 'components/atoms/Icon/Icon';

const FuzzySearchTooltip = () => {
  const { t } = useTranslations();
  const { isDesktop } = useThemeBreakpoint();
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleTooltipToggle = () => {
    setTooltipOpen((prev) => !prev);
  };

  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div>
        <Tooltip
          title={t('general.fuzzySearch.tooltip')}
          {...(!isDesktop && { open: tooltipOpen })}
          disableFocusListener={!isDesktop}
          disableHoverListener={!isDesktop}
          disableTouchListener={!isDesktop}
          slotProps={{
            tooltip: {
              sx: {
                backgroundColor: colors.primary900,
                fontWeight: 400,
                padding: '2px 4px',
                fontSize: '12px',
                lineHeight: '16px',
                letterSpacing: '0%',
                textAlign: 'center',
              },
            },
          }}
        >
          <Box
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            {...(!isDesktop && { onClick: handleTooltipToggle })}
          >
            <Icon type={EIconTypes.globalSearchInfo} fontSize={16} />
          </Box>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default FuzzySearchTooltip;
